import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { User, ApiResponse } from '@app/_models';
import { UserService, AuthenticationService, AlertService } from '@app/_services';
import { TaskService, Task } from '@app/_components/task';
import { Router } from '@angular/router';
import { TaskTypeEnum, NextActionEnum } from '@app/_helpers';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {TaskComponent} from '@app/_components/task/task/task.component';

@Component({
    templateUrl: 'home.component.html', styleUrls: ['home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy
{
	currentUser: User;
	currentUserSubscription: Subscription;
	tasks: Task[] = [];



	get taskTypeEnum() { return TaskTypeEnum; }
	get nextActionEnum() { return NextActionEnum; }

	// list
	datasource;
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];
	columns: any[] = [

		{ field: 'dateDue', header: 'Due', width: '10%' },
		{ field: 'dateCreated', header: 'Age', width: '15%' },
		{ field: 'type', header: 'Type', width: '15%' },

		{ field: 'name', header: 'Name', width: '15%' },
		{ field: 'createdBy.lastName', header: 'Author', width: '15%' },
		{ field: 'document.fileExtension', header: 'Type', width: '15%' },
		{ field: 'document.fileSize', header: 'Size', width: '15%' },


	];

	constructor(
		private authenticationService: AuthenticationService,
		private userService: UserService,
		private alertService: AlertService,
		private taskService: TaskService,
		private router: Router,
    private dialog: MatDialog,
	)
	{
		this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user =>
		{
			this.currentUser = user;
		});
	}

	ngOnInit()
	{
		// load worklist
		// this.loadWorkList();

	}

	addUser(): void
	{
		this.router.navigate(['user-add']);
	}

	loadLazy(event: LazyLoadEvent)
	{
		try
		{
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			const pageNumber = Math.round(event.first / event.rows);
			this.taskService.findByFilterSummary(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					apiResponse =>
					{
						// console.log('users are: ' + JSON.stringify(apiResponse));
						this.datasource = apiResponse.data.users;
						this.recordTotal = apiResponse.page.recordTotal;
						this.tasks = apiResponse.data.tasks;
					},
					apiResponse =>
					{
						console.log('USER LIST!: ' + JSON.stringify(apiResponse));
						this.alertService.error(apiResponse);
					},
					() =>
					{ this.loading = false; }
				);

			if (this.datasource)
			{
				this.tasks = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error)
		{
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	ngOnDestroy()
	{
		// unsubscribe to ensure no memory leaks
		this.currentUserSubscription.unsubscribe();
	}

	daysFromToday(date: Date): any
	{
		let today = new Date();
		let dateDue = new Date(date);
		if (dateDue.valueOf() === 0) { return ''; }
		// console.log(today.valueOf());
		// console.log(dateDue.valueOf());
		return Math.ceil((dateDue.valueOf() - today.valueOf()) / (1000 * 3600 * 24));
	}

	daysFromTodayAbs(date: Date): any
	{
		let today = new Date();
		let dateDue = new Date(date);
		if (dateDue.valueOf() === 0) { return ''; }
		return Math.abs(Math.ceil((dateDue.valueOf() - today.valueOf()) / (1000 * 3600 * 24)));
	}


	priorityColor(dueDate: Date): any
	{
		if (this.daysFromToday(dueDate) === 0) { return 'pink'; }
		if (this.daysFromToday(dueDate) > 0 && this.daysFromToday(dueDate) < 3) { return 'lightyellow'; }
		if (this.daysFromToday(dueDate) < 0) { return 'red'; }
		return 'transparent';
	}
  addTask(tasktypeId: any) {

    const dialogConfig = new MatDialogConfig();
	dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';
    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Add Task',
      taskTypeId: tasktypeId
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        //this.addTaskCB(data);

        // close the dialogBox
        dialogRef.close();
      });
  }
}
